export default "//static.tradera.net/touchweb/static/output/images/qr-code-appstore.3d68de35.svg";